import moment from "moment-timezone";

const normalizeEndDate = (endDate) => {
  if (endDate === null || endDate === undefined || endDate === "" || endDate === "null" || endDate === "undefined") {
    return null;
  }

  const normalized = moment.parseZone(endDate).utc();
  if (!normalized.isValid()) {
    return null;
  }

  return normalized;
};

export const hasAccess = (endDate) => {
  const normalizedEndDate = normalizeEndDate(endDate);
  if (!normalizedEndDate) {
    return true;
  }

  // Stupid Fix - ended_at with date of 1970-01-01
  if (normalizedEndDate.clone().local().isBefore(moment.utc("2023-01-01", "YYYY-MM-DD"))) {
    return true;
  }

  if (normalizedEndDate.clone().local().isBefore(moment.utc())) {
    return false;
  }
  return true;
};

export const accessEnded = (endDate) => {
  const normalizedEndDate = normalizeEndDate(endDate);
  if (!normalizedEndDate) {
    return false;
  }

  // Stupid Fix - ended_at with date of 1970-01-01
  if (normalizedEndDate.isBefore(moment.utc("2023-01-01", "YYYY-MM-DD"))) {
    return false;
  }

  if (normalizedEndDate.isBefore(moment.utc())) {
    return true;
  }
  return false;
};
